// For reusable convenience methods

export function FormatDateToLocal(date){
    if (!date || date === ''){
        return '';
    }
    
    let dateObject = new Date();
    
    if (typeof(date) !== typeof(Date)){
        let dt = Date.parse(date);
        dateObject = new Date(dt);
    }
    else{
        dateObject = date;
    }

    return dateObject.toLocaleDateString();
}